
   getFacebookWallPosts = function (options)
   {
      // console.log('loadFacebookWallPosts', options)
      var template    = options.template
      var container   = options.container
      var username    = options.username
      var accessToken = options.accessToken
      var limit       = options.limit

      $.getJSON("https://graph.facebook.com/" + username + "/posts?" + accessToken + "&callback=?",
       {
          'limit': limit
       }, 
      function (data)
      {
        var i = 0;
        $.each(data.data, function ()
        {
           if (this.message !== undefined && i < limit)
           {
              // console.log('post', this)
              var post = {
                link      : this.link,
                image_url : this.picture,
                message   : this.message
              }
              container.append(template(post))
              i++;
           }
        })
      }).done(function(result)
      {
        if(result.error){
          console.log( "getFacebookWallPosts Error" , result.error.message);   
        }
        else{
          console.log( "getFacebookWallPosts Done" , result);    
        }
      })
   }


   loadFacebookWallPosts = function (username)
   {

     $.get("https://graph.facebook.com/oauth/access_token",
     {
      'grant_type'    : "client_credentials",
      'client_id'     : "793272764097951",
      'client_secret' : "ed4e290047dca8da8cb9910fb0ddc9b0"
     }, 
     function (data)
     {
        var facebookfeed_html   = $('#template--collection__facebookfeed').html();
        var template            = Handlebars.compile(facebookfeed_html);
        var options             = {
          username        : username, 
          accessToken     : data, 
          limit           : 66,
          container       : $('.facebook-wall ul'), 
          template        : template
        }
        getFacebookWallPosts( options );
     });

   }
